import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import DataTable from "../_Components/DataTable";
import _ from "lodash";
import { Button } from "react-bootstrap";
import Switch from "@mui/material/Switch";
import { tools } from "../../../core/utils/tools";

function DataGrid({ data, setCreatePackageModal, setSelectedPackageId }) {
  const columns = useMemo(() => [
    {
      accessor: "id",
      Header: "#",
      minWidth: 50,
    },
    {
      accessor: "title",
      Header: "عنوان",
      minWidth: "100px",
    },

    {
      Header: "قیمت",
      minWidth: "100px",
      Cell: ({ row }) => <div className="text-center">{tools.formatPriceNumber(row.original.price)}</div>,
    },
    {
      Header: "تاریخ شروع پکیج",
      minWidth: "100px",
      Cell: ({ row }) => <div className="text-center">{String(row.original.startDate)?.split("T")[0]}</div>,
    },
    {
      Header: "تاریخ پایان پکیج",
      minWidth: "100px",
      Cell: ({ row }) => <div className="text-center">{String(row.original.endDate)?.split("T")[0]}</div>,
    },
    {
      Header: "وضعیت",
      minWidth: "100px",
      Cell: ({ row }) => (
        <div className="text-center">
          <Switch checked={row.original.isActive} />
        </div>
      ),
    },
    {
      accessor: "createdPersianTime",
      Header: " زمان ایجاد ",
      minWidth: "90px",
      maxWidth: "90px",
    },

    {
      Header: "عملیات",
      accessor: "",
      minWidth: 150,
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          <Button
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            onClick={() => {
              setSelectedPackageId(row.original.id);
              setCreatePackageModal(true);
            }}
            title="ویرایش مشخصات پکیج"
          >
            <i className="far fa-edit text-small"></i>
          </Button>

          <Link
            className=" btn btn-light-success btn-sm btn-icon"
            to={`/amusementPackage/${row.original.id}`}
            title="تغییر آیتم های پکیج"
          >
            <i className="far fa-plus text-small" />
          </Link>
        </div>
      ),
    },
  ]);

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };

  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGrid;
